import { lineGoodsAmount } from '@tcr-erp/shared';
import type { OrderItem } from '../types';

/**
 * Bỏ giá flash khỏi một dòng giỏ, trả về giá niêm yết.
 *
 * Dùng cho hai ca: thu ngân chủ động bấm bỏ, và BE báo hết suất flash lúc ghi
 * hoá đơn. Cả hai đều phải cho ra CÙNG một hình dạng dòng, nếu không đơn sẽ
 * mang `flash_sale_item_id` mồ côi trỏ tới một suất không còn tồn tại — BE tra
 * theo id đó lúc chốt và đơn hỏng ở bước cuối, sau khi khách đã đưa tiền.
 *
 * Trả về CHÍNH object cũ khi dòng không phải flash: hàm này chạy qua cả giỏ ở
 * ca "hết suất", tạo bản sao cho mọi dòng sẽ làm React render lại toàn bảng.
 */
export function dropFlashPrice(item: OrderItem): OrderItem {
  if (!item.flash_sale_item_id) return item;
  // `retailPrice` là giá niêm yết đã chụp lúc dựng dòng (`variantToOrderItem`).
  // Thiếu nó thì GIỮ giá hiện tại — hạ về 0 là tặng không món hàng.
  const price = item.retailPrice ?? item.price;
  return {
    ...item,
    price,
    totalAmount: lineGoodsAmount(price, item.quantity),
    flash_sale_item_id: undefined,
    flashRemaining: undefined,
    flashMaxPerCustomer: undefined,
    flashEndAt: undefined,
  };
}
